module.exports = __webpack_public_path__ + "static/media/BlueOval.68c1b398.svg";